import Image9 from "@/common/assets/image/Mainpage/Partners/partner9.svg"
import Image17 from "@/common/assets/image/Mainpage/Partners/partner17.svg"
import Image18 from "@/common/assets/image/Mainpage/Partners/partner18.svg"
import Image19 from "@/common/assets/image/Mainpage/Partners/partner19.svg"
import Image25 from "@/common/assets/image/Mainpage/Partners/partner25.svg"
import Image26 from "@/common/assets/image/Mainpage/Partners/partner26.svg"
import Image27 from "@/common/assets/image/Mainpage/Partners/partner27.svg"
import Image28 from "@/common/assets/image/Mainpage/Partners/partner28.svg"
import Image33 from "@/common/assets/image/Mainpage/Partners/partner33.svg"
import Image34 from "@/common/assets/image/Mainpage/Partners/partner34.svg"
import Image46 from "@/common/assets/image/Mainpage/Partners/partner46.svg"
import Sinxi from "@/common/assets/image/Mainpage/Partners/sinxi.svg"
import YJ from "@/common/assets/image/Mainpage/Partners/YJ.svg"
import Zhong from "@/common/assets/image/Mainpage/Partners/zhong.svg"
import Argo from "@/common/assets/image/Mainpage/Partners/argo.svg"
import gch from "@/common/assets/image/partners/gch.svg"
import mmxtion from "@/common/assets/image/partners/mmxtion.svg"
import webcomm from "@/common/assets/image/partners/webcomm.svg"
import Moralis from "@/common/assets/image/partners/moralis.svg"

export const COMPANY_DATA = [
  {
    image: Image27,
    tag: ["Accelerator"],
    tagD: "",
    alt: "500 startups",
    url: "https://500.co/"
  },
  {
    image: Image19,
    tag: ["Accelerator"],
    tagD: "",
    alt: "Plug and Play",
    url: "https://www.plugandplaytechcenter.com/"
  },
  {
    image: Image46,
    tag: ["Accelerator"],
    tagD: "",
    alt: "DRAPER University",
    url: "https://www.draperuniversity.com/"
  },
  {
    image: Image28,
    tag: ["Accelerator"],
    tagD: "",
    alt: "pwc",
    url: "https://www.pwc.tw/"
  },
  {
    image: Image17,
    tag: ["Accelerator"],
    tagD: "",
    alt: "Microsoft for Startups",
    url: "https://startups.microsoft.com/"
  },
  {
    image: Image33,
    tag: ["Accelerator"],
    tagD: "",
    alt: "SYSTEX 精誠加速器",
    url: "https://aiplus.systex.com/"
  },
  {
    image: Image25,
    tag: ["Accelerator"],
    tagD: "",
    alt: "Xcelerator",
    url: "https://xcelerator.berkeley.edu/"
  },
  {
    image: Image18,
    tag: ["Accelerator"],
    tagD: "",
    alt: "Microsoft",
    url: "https://www.microsoft.com/zh-tw/"
  },
  {
    image: Image9,
    tag: ["Cooperation"],
    tagD: "",
    alt: "DowJones",
    url: "https://www.dowjones.com/"
  },
  {
    image: Image26,
    tag: ["Cooperation"],
    tagD: "",
    alt: "Jumio",
    url: "https://www.jumio.com/"
  },
  {
    image: Image34,
    tag: ["business cooperation"],
    tagD: "",
    alt: "東宜資訊 TIIS",
    url: "https://www.tiis.com.tw/"
  },
  {
    image: Sinxi,
    tag: ["business cooperation"],
    tagD: "",
    alt: "Sinxi",
    url: null
  },
  {
    image: YJ,
    tag: ["business cooperation"],
    tagD: "",
    alt: "YJ",
    url: null
  },
  {
    image: Zhong,
    tag: ["business cooperation"],
    tagD: "",
    alt: "Zhong",
    url: "https://zhongyinlawyer.com.tw/"
  },
  {
    image: Argo,
    tag: ["business cooperation"],
    tagD: "",
    alt: "argo",
    url: "https://argoblocks.com/"
  },
  {
    image: gch,
    tag: ["business cooperation"],
    tagD: "",
    alt: "詹勳華律師事務所",
    url: "https://www.facebook.com/scottchanesq/"
  },
  {
    image: webcomm,
    tag: ["Cooperation"],
    tagD: "",
    alt: "webcomm",
    url: "https://www.webcomm.com.tw/web/tw/"
  },
  {
    image: mmxtion,
    tag: ["Cooperation"],
    tagD: "",
    alt: "mmxtion",
    url: "https://www.mmxtion.com.tw"
  },
  {
    image: Moralis,
    tag: ["Cooperation"],
    tagD: "",
    alt: "moralis",
    url: ""
  }
]
